module.exports = __webpack_public_path__ + "b00f5d7b224467938cceb6e9738bedcc.pdf";